import api from './api';

export type GatewayWebrtcAgentReport = {
  pool_id?: number;
  reported_at?: string;
  whip_base_set?: boolean;
  whip_base_host?: string;
  whip_base_auto?: boolean;
  edge_pipeline?: string;
  whip_ffmpeg_ok?: boolean;
  go2rtc_local_ok?: boolean;
  whip_forwarding?: boolean;
  whip_ts_buffer_bytes?: number | null;
  agent_version?: string;
};

export type GatewayWebrtcCameraStatus = {
  cctv_id: number;
  name: string;
  stream: string;
  hls_fresh: boolean;
  central_active: boolean;
  yaml_slot: boolean;
  hls_republish: boolean;
  mode: string;
  gateway_last_seen_at?: string | null;
};

export type GatewayWebrtcStatus = {
  pool_id: number;
  summary: string;
  webrtc_ready: boolean;
  central_go2rtc_available: boolean;
  central_active_streams: string[];
  central_stream_slots: string[];
  slot_only_count?: number;
  hls_fresh_count?: number;
  hls_republish_count?: number;
  cameras?: GatewayWebrtcCameraStatus[];
  republish_errors?: Record<string, string>;
  hls_internal_base?: string;
  agent: GatewayWebrtcAgentReport | null;
  agent_stale: boolean;
  agent_age_sec: number | null;
  gateway_nvr_bypass?: boolean | null;
  gateway_stream_width?: number | null;
  whip_ts_buffer_bytes?: number | null;
  ui_guide?: string;
};

export async function fetchGatewayWebrtcStatus(poolId: number | string): Promise<GatewayWebrtcStatus> {
  return api.get(`/api/pools/${poolId}/gateway/webrtc-status`, undefined, { useCache: false });
}

export async function applyGatewayWebrtcHlsRepublish(
  poolId: number | string
): Promise<{ applied: { ok_count?: number; total?: number; errors?: Record<string, string> }; status: GatewayWebrtcStatus }> {
  return api.post(`/api/pools/${poolId}/gateway/webrtc-hls-republish`);
}
